import { GlLoadingIcon, GlSprintf } from '@gitlab/ui';
import { s__, __, sprintf } from '~/locale';
import ClipboardButton from '~/vue_shared/components/clipboard_button.vue';
/**
 * Renders an inline field, whose value can be copied to the clipboard,
 * for use in the GitLab sidebar (issues, MRs, etc.).
 */ export default {
    name: 'CopyableField',
    components: {
        ClipboardButton,
        GlLoadingIcon,
        GlSprintf
    },
    props: {
        value: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        clipboardTooltipText: {
            type: String,
            required: false,
            default: undefined
        }
    },
    computed: {
        clipboardProps () {
            return {
                category: 'tertiary',
                tooltipBoundary: 'viewport',
                tooltipPlacement: 'left',
                text: this.value,
                title: this.clipboardTooltipText || sprintf(this.$options.i18n.clipboardTooltip, {
                    name: this.name
                })
            };
        },
        loadingIconLabel () {
            return sprintf(this.$options.i18n.loadingIconLabel, {
                name: this.name
            });
        }
    },
    i18n: {
        loadingIconLabel: __('Loading %{name}'),
        clipboardTooltip: __('Copy %{name}'),
        templateText: s__('Sidebar|%{name}: %{value}')
    }
};
